<template>
  <StoreLocatorConfigSection :title="$t('message.storeLocator.basic.title')">
    <div class="sl-basic">
      <div class="sl-basic__form">
        <v-text-field
          :label="$t('message.storeLocator.basic.url')"
          :value="config.domain"
          disabled
        ></v-text-field>
        <v-text-field
          :label="$t('message.storeLocator.basic.name')"
          v-model="form.name"
        ></v-text-field>
      </div>
      <StoreLocatorConfigImageUploader :src="config.logo" @change="setFile" />
      <div class="sl-basic__form align-self-center">
        <div class="forms-wrapper">
          <StoreLocatorConfigColorPicker
            v-model="form.color_1"
            :label="$t('message.storeLocator.basic.primaryColor')"
          />
          <StoreLocatorConfigFaviconUploader
            :favicon-src="config.favicon"
            @change="setFavicon"
          />
        </div>
      </div>
    </div>
  </StoreLocatorConfigSection>
</template>

<script>
import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";
import StoreLocatorConfigColorPicker from "@/components/StoreLocator/StoreLocatorConfigColorPicker";
import StoreLocatorConfigImageUploader from "@/components/StoreLocator/StoreLocatorConfigImageUploader";
import StoreLocatorConfigFaviconUploader from "@/components/StoreLocator/StoreLocatorConfigFaviconUploader";

const defaultForm = {
  domain: "",
  name: "",
  color_1: "#000000",
  logo: null
};

export default {
  name: "StoreLocatorConfigBasic",
  components: {
    StoreLocatorConfigSection,
    StoreLocatorConfigColorPicker,
    StoreLocatorConfigImageUploader,
    StoreLocatorConfigFaviconUploader
  },
  props: {
    config: {
      type: Object
    }
  },
  data: () => ({
    form: null,
    logoSrc: "",
    logoFile: null,
    faviconFile: null
  }),
  watch: {
    config: {
      handler() {
        this.setForm();
      },
      deep: true
    },
    form: {
      handler(data) {
        this.$emit("form-change", data);
      },
      deep: true
    }
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      if (this.config) {
        const { name, color_1, logo } = this.config;
        this.form = { name, color_1 };
        this.logoSrc = logo;
      } else {
        this.form = { ...defaultForm };
      }
    },

    setFile(file) {
      this.logoFile = file;
      this.$emit("file-change", this.logoFile);
    },

    setFavicon(file) {
      this.faviconFile = file;
      this.$emit("favicon-change", this.faviconFile);
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-basic {
  display: flex;

  &__form {
    flex: 1 1 auto;
  }
}

.forms-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
